import { axios } from '@/utils/request'

const api = {
  QuerySystemExtListForSub: '/sso/subjectServiceSystemExt/querySystemExtListForSub',
  PlatformUniteInterface: '/sso/ThirdInterface/platformUniteInterface', // 平台系统通用接口的请求转发
  GetAnnouncementYhEjectDetail: '/sso/announcementGroup/getAnnouncementYhEjectDetail',
  QueryMenuStatus: '/sso/menu/queryMenuStatus', // 获取用户状态
  AddMenuStatus: '/sso/menu/addMenuStatus', // 保存用户状态
  RecordMenuOpt: '/sso/menuStatistics/recordMenuOpt', // 统计点击次数
  NoticeThirdSystemClearCache: '/sso/serviceInfo/noticeThirdSystemClearCache', // 通知第三方清除缓存
  DownloadImg: '/upload/download', // 下载
  QuerySystemParamsPage: '/sso/systemParams/querySystemParamsPage',
  checkSelMuchJump: '/sso/subjectServiceSystemExt/checkSelMuchJump',
  bannerList: '/openApi/banner/queryList',
  forward: '/sso/forward', // 资金转发接口
  queryMsgNoticePage: '/sso/msgNotice/queryMsgNoticePage' // 获取消息通知分页

}

export default api
export const querySystemExtListForSub = async params => axios.post(api.QuerySystemExtListForSub, params)
export const PlatformUniteInterface = async params => axios.post(api.PlatformUniteInterface, params)
export const GetAnnouncementYhEjectDetail = async params => axios.post(api.GetAnnouncementYhEjectDetail, params)
// export const chooseLanguage = async params => axios.post(api.ChooseLanguage, params)
export const queryMenuStatus = async params => axios.post(api.QueryMenuStatus, params)
export const addMenuStatus = async params => axios.post(api.AddMenuStatus, params, { async: false })
export const recordMenuOpt = async (params) => axios.post(api.RecordMenuOpt, params)
export const noticeThirdSystemClearCache = async (params) => axios.post(api.NoticeThirdSystemClearCache, params)
export const DownloadImg = async params => axios.post(api.DownloadImg, params, { responseType: 'blob' })
export const QuerySystemParamsPage = async params => axios.post(api.QuerySystemParamsPage, params)
export const checkSelMuchJump = async params => axios.post(api.checkSelMuchJump, params)
export const bannerList = async params => axios.post(api.bannerList, params)
export const forward = async params => axios.post(api.forward, params)
export const queryMsgNoticePage = async params => axios.post(api.queryMsgNoticePage, params, false)
